import { render, staticRenderFns } from "./TipText.vue?vue&type=template&id=6077aa89&scoped=true&"
import script from "./TipText.vue?vue&type=script&lang=js&"
export * from "./TipText.vue?vue&type=script&lang=js&"
import style0 from "./TipText.vue?vue&type=style&index=0&id=6077aa89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6077aa89",
  null
  
)

export default component.exports